import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DialogComponent} from './dialog.component';
import {OverlayModule} from '@angular/cdk/overlay';
import {ButtonIconModule} from '@tisa-group/client-ui/components/button-icon';
import {IconModule} from '@tisa-group/client-ui/components/icon';

@NgModule({
  declarations: [DialogComponent],
  exports: [DialogComponent],
  imports: [CommonModule, OverlayModule, ButtonIconModule, IconModule],
})
export class DialogModule {}
